/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { minNumber, requiredNumber, requiredObject, requiredString, ValidatorSchema } from '@irian-ro/util-forms';
import { ProductCustomsClearanceDtoModel } from '@well/product-customs-clearance/domain';

export const productCustomValidators : ValidatorSchema<ProductCustomsClearanceDtoModel> = {
    commodityDescription: [requiredString],
    quantity:[requiredNumber, minNumber(1)],
    unitPrice: [requiredObject],
    customsValue: [requiredObject],
    countryOfManufacture: [requiredString],
    totalWeight: [requiredNumber],
    customLabel: [requiredString],
    quantityUnits:[requiredObject],

}
